// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"474108b9c4616674","8551":"4261d49717e4455d"}[chunkId] + ".css";
};